<script>
import { COMUNICANTE_CAMPAIGN } from '../../constants';

export default {
  name: 'ReportFiltersComunicanteCampaign',
  emits: ['comunicanteCampaignFilterSelection'],
  data() {
    const options = Object.values(COMUNICANTE_CAMPAIGN).map(option => ({
      ...option,
      name: this.$t(option.translationKey),
    }));

    return {
      selectedOption: options[0],
      options,
    };
  },
  methods: {
    updateSelection(selectedOption) {
      this.selectedOption = selectedOption;
      this.$emit('comunicanteCampaignFilterSelection', selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="id"
      label="name"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateSelection"
    />
  </div>
</template>
